import {Deposit} from './deposit';
import {Payout} from './payout';
export class Payment {
  payout: Payout = new Payout();
  deposit: Deposit = new Deposit();
}



// WEBPACK FOOTER //
// ./src/app/model/shared/transaction/payment.ts